var map = {
	"./": "2de2",
	"./development": "9591",
	"./development.ts": "9591",
	"./env": "759a",
	"./env.ts": "759a",
	"./index": "2de2",
	"./index.ts": "2de2",
	"./mock": "61ca",
	"./mock.ts": "61ca",
	"./production": "4d7c",
	"./production.ts": "4d7c",
	"./test": "8711",
	"./test.ts": "8711",
	"./types": "b40b",
	"./types.ts": "b40b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "354b";